export default 
    {
        homeName: 'Dashboard'
    }
